import storeHelpers from '@/utils/helpers/store';

import {
  isValidAddressForm,
  isValidHousingForm,
  isValidElevator,
  isValidFurnitureTransportForm,
  isValidParkingArea,
  isSpecialLogementType,
  addressMutation,
} from '../utils';
import { Connector } from '@/backendConnector';

const state = {
  loading: {
    address: {
      city: '',
      country: '',
      postal: '',
      street: '',
    },
    floor: {
      all_in_lift: null,
      floor: '',
      lift: null,
      lift_comment: '',
      mm_obligatoire: null,
      mm_utilisable: null,
      stairs: null,
      type_logement: null,
      cave: null,
    },
    parking: {
      type: '',
      portage: '',
      vl: null,
    },
  },
};

const actions = {
  addressSaveState({ getters }) {
    return Connector.getInstance()
      .postLoadingAddress({ address: getters.address });
  },
  housingSaveState({
    getters,
  }) {
    const promises = [
      Connector.getInstance()
        .postLoadingAddress({ address: getters.address, floor: getters.floor }),
    ];
    if (isSpecialLogementType(getters.floor.type_logement)) {
      promises.push(Connector.getInstance().deleteLoadingParking());
    }
    return Promise.all(promises);
  },
  furnitureTransportSaveState({
    getters,
  }) {
    return Connector.getInstance()
      .postLoadingAddress({ floor: getters.floor });
  },
  parkingAreaSaveState({
    getters,
  }) {
    return Connector.getInstance()
      .postLoadingParking(getters.parking);
  },
};

const getters = {
  ...storeHelpers.getGetters(state.loading, 'loading'),
  ...storeHelpers.getGetters(state.loading.floor, 'loading'),
  ...storeHelpers.getGetters(state.loading.address, 'loading'),
  ...storeHelpers.getGetters(state.loading.parking, 'loading'),
  loading: state => state.loading,
  'address/isValidForm': state => isValidAddressForm(state.loading),
  'housing/isValidForm': state => isValidHousingForm(state.loading),
  'elevator/isValidForm': state => isValidElevator(state.loading),
  'furnitureTransport/isValidForm': state => isValidFurnitureTransportForm(state.loading),
  'parkingArea/isValidForm': state => isValidParkingArea(state.loading),
};

const mutations = {
  ...addressMutation('loading'),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
